import { Component, ElementRef, Input, OnInit } from '@angular/core';
import { ContentService, DcrKeyPipe } from '@blk/cwp-ng-framework';
import { TealiumAnalyticsEvent, TealiumAnalyticsService, TealiumConstants } from '@ddt-web/analytics';
import { InjectQueryParam } from '@ddt-web/generic-utils';
import { DebugQueryParamKey, SharedQueryParamKey } from '@ddt-web/url';

@Component({
	// eslint-disable-next-line @angular-eslint/component-selector
	selector: 'info-bubble',
	templateUrl: './info-bubble.component.html',
	styleUrls: ['./info-bubble.component.scss']
})
export class InfoBubbleComponent implements OnInit {

	// mainly for debugging purposes
	@InjectQueryParam(SharedQueryParamKey.SHOW_TOOLTIP) public readonly showTooltipQp: boolean;
	@InjectQueryParam(DebugQueryParamKey.SHOW_EDITOR) public readonly showEditorQp: boolean;

	@Input() public dcrKey: string;
	@Input() public defaultValue: string;
	@Input('stop-event-propagation') public stopEventPropagation: boolean = false;
	@Input() private customTracking: string;
	public dcrValue: string;

	constructor(
		private elementRef: ElementRef,
		private contentService: ContentService,
		private tealiumAnalyticsService: TealiumAnalyticsService
	) { }

	public ngOnInit() {
		this.dcrValue = this.contentService.get(this.dcrKey, this.defaultValue?.toString());

		if (this.showTooltipQp || this.showEditorQp) {
			this.dcrValue = `${new DcrKeyPipe().transform(this.dcrKey)}: ${this.dcrValue}`;
		}

		if (!this.dcrValue?.trim()) {
			this.elementRef.nativeElement.style.display = 'none';
		}
	}

	// Overrides auto linkName generation from DCR keys if a custom one is provided
	public onClick(e: Event): void {
		if (this.stopEventPropagation) {
			e.stopPropagation();
		}
		const linkName = this.customTracking ?? this.dcrKey.replace('_TOOLTIP_TOOLTIP', '_TOOLTIP');
		const event = new TealiumAnalyticsEvent(TealiumConstants.TOOLS_EVENT.TOOL_TIP, { linkName });
		this.tealiumAnalyticsService.trackEventTealium(event);
	}

}
